import { put, takeEvery, takeLatest, select } from 'redux-saga/effects';

import CustomerDetails from '../../../models/CustomerDetails';

import { SALESFORCE_DATA_READY } from '../SFDataService/actions';

import * as Actions from './actions';

export function* populateCustomerDetails(action) {
  // action.account;
  // action.opportunity;
  let details = yield select(state => state.customerDetails);
  if (action.opportunity !== null) {
    if (details === null) {
      details = new CustomerDetails(
        action.opportunity.getId(),
        action.opportunity.getPointOfSalesAlreadyUsed(),
        action.opportunity.getPointOfSalesUsed(),
        action.opportunity.getNewOpen(),
        action.opportunity.getInstallationDate(),
      );
    } else {
      details.setId(action.opportunity._id);
      details.setPointOfSalesAlreadyUsed(action.opportunity._pointOfSalesAlreadyUsed);
      details.setPointOfSalesUsed(action.opportunity._pointOfSalesUsed);
      details.setNewOpen(action.opportunity._newOpen);
      details.setInstallationDate(action.opportunity._installationDate);
    }
  }
  yield put(Actions.customerDetailsUpdated(details));
}

export function* savedCustomerDetails(action) {
  let details = new CustomerDetails()
    .setId(action.values.id)
    .setPointOfSalesAlreadyUsed(action.values.pointOfSalesAlreadyUsed)
    .setPointOfSalesUsed(action.values.pointOfSalesUsed)
    .setNewOpen(action.values.newOpen)
    .setInstallationDate(action.values.installationDate)
    .setEstablishmentArea(action.values.establishmentArea);

  yield put(Actions.customerDetailsDataReady(details));
}

export function* customerDetailsListener() {
  yield takeLatest(SALESFORCE_DATA_READY, populateCustomerDetails);
  yield takeEvery(Actions.CUSTOMER_DETAILS_SAVED, savedCustomerDetails);
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerDetailsService/saga.js